export default "__VITE_ASSET__CE44Fd0w__"